import { render, staticRenderFns } from "./AsIntendedUserList.vue?vue&type=template&id=f2eb02c0&"
import script from "./AsIntendedUserList.vue?vue&type=script&lang=js&"
export * from "./AsIntendedUserList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports